// notificationSlice.js — real-time + persisted notifications
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const API_URL = "";

const getConfig = () => ({
  withCredentials: true,
});

// Fetch persisted notifications from DB
export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL}/api/notifications`, getConfig());
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return rejectWithValue("ไม่สามารถโหลดการแจ้งเตือนได้");
    }
  }
);

// Mark single as read
export const markAsRead = createAsyncThunk(
  "notifications/markAsRead",
  async ({ id, scope = "personal" }, { getState }) => {
    try {
      await axios.put(`${API_URL}/api/notifications/${id}/read`,
        { scope },
        getConfig()
      );
      return { id, scope };
    } catch (err) {
      console.error("markAsRead error:", err);
      return null;
    }
  }
);

// Mark all as read
export const markAllAsRead = createAsyncThunk(
  "notifications/markAllAsRead",
  async (_, { getState }) => {
    try {
      await axios.put(`${API_URL}/api/notifications/read-all`, {}, getConfig());
      return true;
    } catch (err) {
      console.error("markAllAsRead error:", err);
      return false;
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    list: [],
    unreadCount: 0,
    loading: false,
    connected: false,
  },
  reducers: {
    addNotification(state, action) {
      // Avoid duplicates
      if (!state.list.find((n) => n.id === action.payload.id)) {
        state.list.unshift(action.payload);
        state.unreadCount += 1;
      }
    },
    markReadLocal(state, action) {
      const item = state.list.find((n) => n.id === action.payload);
      if (item && !item.isRead) {
        item.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllReadLocal(state) {
      state.list.forEach((n) => (n.isRead = true));
      state.unreadCount = 0;
    },
    setConnected(state, action) {
      state.connected = action.payload;
    },
    clearNotifications(state) {
      state.list = [];
      state.unreadCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (s) => { s.loading = true; })
      .addCase(fetchNotifications.fulfilled, (s, a) => {
        s.loading = false;
        s.list = a.payload || [];
        s.unreadCount = (a.payload || []).filter((n) => !n.isRead).length;
      })
      .addCase(fetchNotifications.rejected, (s) => { s.loading = false; })
      .addCase(markAsRead.fulfilled, (s, a) => {
        if (a.payload) {
          const item = s.list.find((n) => n.id === a.payload.id);
          if (item && !item.isRead) {
            item.isRead = true;
            s.unreadCount = Math.max(0, s.unreadCount - 1);
          }
        }
      })
      .addCase(markAllAsRead.fulfilled, (s) => {
        s.list.forEach((n) => (n.isRead = true));
        s.unreadCount = 0;
      });
  },
});

export const {
  addNotification,
  markReadLocal,
  markAllReadLocal,
  setConnected,
  clearNotifications,
} = notificationSlice.actions;
export default notificationSlice.reducer;
